import Calendar from '../../../collection/calendar';
import Collection from '../../../collection';
import View from '../../view';

import { datify, fmt, zp, } from '../../../utils/date';






export default View.extend( {

    serialize() {
        const { pattern } = this.options;
        // 1st of August, 2022 is a Monday - so,
        // it will be the first cell in calendar
        const dateSeed = datify( '2022-08-01 00:00:00' );

        return {
            calendar: new Calendar( dateSeed ),

            ['color-scheme']: this.options['color-scheme'],

            // как должен выглядеть реальный dates для calendar?
            // { date:X, ... }
            // X может быть как TimeStamp, так и строкой
            dates: new Collection( [
                ...Object.keys( pattern.v )
                    .map( d => ({
                        date: datify( `${zp( d )}.08.2022 00:00:00` ),
                        pickedUp: true,
                        toggleOff: pattern.remove[d]
                    })),
                ...Object.keys( pattern.add )
                    .map( d => ({ 
                        date: datify( `${zp( d )}.08.2022 00:00:00` ), 
                        pickedUp: true
                    }))
            ] )
        }
    },

    [View.event( 'Calendar:date:toggle' )](date) {
        return toggleDate.call( this, date ), 
            this.render();
    },

} );





function toggleDate(date) {
    const { pattern, ...props } = this.model.clonePattern( this.options.pattern );
    pattern.value = [...this.options.pattern.value];
    pattern.v = { ...this.options.pattern.v };
    pattern.add = { ...this.options.pattern.add };
    pattern.remove = { ...this.options.pattern.remove };

    this.options.pattern = pattern;

    const finalize = () => this.model.set( props );

    if (pattern.add[fmt( date, 'D' )])
        return delete pattern.add[fmt( date, 'D' )], finalize();

    if (pattern.remove[fmt( date, 'D' )])
        return delete pattern.remove[fmt( date, 'D' )], finalize();

    if (pattern.v[fmt( date, 'D' )])
        return pattern.remove[fmt( date, 'D' )] = true, finalize();

    return pattern.add[fmt( date, 'D' )] = true, finalize();
}




// WEBPACK FOOTER //
// ./src/js/view/module/schedule/pattern.monthly.js